/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiEmployeesIdCvDownloadPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiEmployeesIdCvDownload200Schema = z.any();

export const getApiEmployeesIdCvDownloadQueryResponseSchema = z.lazy(
  () => getApiEmployeesIdCvDownload200Schema,
);
